import React from "react";
import {
  toCompactNumber,
  formatToCommaString,
  getGrowthTrendColor,
  numDifferentiation,
} from "../helper/format";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

// const generateData = () => {
//   let data = [];

//   for (let i = 1; i <= 31; i++) {
//     data.push({
//       name: i,
//       "Last Month": Math.floor(Math.random() * 400000),
//       "Current Month": Math.floor(Math.random() * 400000),
//     });
//   }

//   return data;
// };

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const lastMonthValue = payload[0].payload["Last Month"];
    const currentMonthValue = payload[0].payload["Current Month"];
    const growth = payload[0].payload.growthPercent;

    return (
      <div
        style={{
          background: "rgba(255,255,255,0.56)",
          borderRadius: 12,
          padding: 16,
        }}
      >
        <p
          style={{
            margin: 8,
            fontSize: 14,
            fontWeight: 600,
            color: "rgba(0, 0, 0, 0.72)",
          }}
        >{`Last Month: ${
          lastMonthValue == null
            ? "No data"
            : numDifferentiation(lastMonthValue) +
              " (" +
              formatToCommaString(lastMonthValue) +
              ")"
        }`}</p>
        <p
          style={{
            margin: 8,
            fontSize: 14,
            fontWeight: 600,
            color: "rgba(226, 19, 110, 1)",
          }}
        >{`Current Month: ${
          currentMonthValue == null
            ? "No data"
            : numDifferentiation(currentMonthValue) +
              " (" +
              formatToCommaString(currentMonthValue) +
              ")"
        }`}</p>
        <p
          style={{
            margin: 8,
            fontSize: 14,
            fontWeight: 600,
            color: getGrowthTrendColor(growth),
          }}
        >{`Growth: ${growth == null ? "N/A" : growth.toFixed(2) + "%"}`}</p>
      </div>
    );
  }

  return null;
};

export default function ResponsiveLineChart({ data }) {
  return (
    <ResponsiveContainer width="99%" height="100%">
      <LineChart
        height={440}
        data={data}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis axisLine={false} tickLine={false} dataKey="name" />
        <YAxis
          axisLine={false}
          tickLine={false}
          tickFormatter={toCompactNumber}
        />
        <Tooltip content={<CustomTooltip />} />
        <Legend
          layout="vertical"
          verticalAlign="top"
          iconType="square"
          wrapperStyle={{ top: -4, right: 0 }}
        />
        <Line
          type="monotone"
          dataKey="Last Month"
          stroke="rgba(199, 199, 199, 1)"
          strokeWidth={3}
          dot={false}
        />
        <Line
          type="monotone"
          dataKey="Current Month"
          stroke="rgba(226, 19, 110, 1)"
          strokeWidth={3}
          dot={false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
